import { FC, useContext, useState, useEffect } from "react";
import { CardMolecule, SwapCardButton } from "../..";
import { CardContext, SocketContext, TableContext, TeamContext, UserContext } from "../../../../context";
import { useBoardDisplayView, useSound } from "../../../../hooks";
import { IPlayer } from "../../../../interfaces";
import { MainButton, PinkNotification } from "../../../atoms";
import questionCrown from "../../../../assets/icons/questionCrown.svg";
import { useTranslation } from "react-i18next";

interface IChosenDilemmaCard {
    isFullScreenOn?: boolean;
    isTheFullScreenOn: boolean;
    isDilemmaOwnerButtonShown?: boolean;
}

const ChosenDilemmaCard : FC<IChosenDilemmaCard> = ({isFullScreenOn, isTheFullScreenOn, isDilemmaOwnerButtonShown}) => {
    const { t } = useTranslation();
    const { finishedChoosingDilemmaCardSocketEmit } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const { dataOfDoubleClickedSolutionCard } = useContext(CardContext);
    const { isDilemmaChosen } = useContext(TableContext);
    const [ isJokerButtonHovered, setIsJokerButtonHovered ] = useState<boolean>(false);
    const [isExchangeButtonHovered, setIsExchangeButtonHovered] = useState<boolean>(false);
    const [areTipsVisible, setAreTipsVisible] = useState<boolean>(false);
    const proposedCardsObject = game?.gameInfo.proposedSolutionCards;
    const objectLength: number = proposedCardsObject ? Object.keys(proposedCardsObject).length : 0;
    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;
    const [challengeCard] = useBoardDisplayView();
    const dilemmaOwnerColor: string = game?.players.find((player: IPlayer) => player.email === game.gameInfo.currentPlayerEmail)?.color || "pink";
    let isAnyCardProposedOnTheTable = objectLength > 0;
    const dilemmaOwner = game?.players.find((player: IPlayer) => { return game.gameInfo.currentPlayerEmail === player.email });
    const {playSound} = useSound();

    const checkIsSoundNeededToBePlayed = () => {
        if (!isFullScreenOn) playSound("/sounds/ItemHover.mp3");
    }

    const redirectScreensAfterDilemamWasChosen = () => {
        // setIsDilemmaChosen(true);
        finishedChoosingDilemmaCardSocketEmit();
    }

    return (
        <div className={`challenge_card_animation challenge_card_zIndex_on_hover  ${dataOfDoubleClickedSolutionCard ? "zindex_one" : ""} `} >
            <div className={` question_picked__content ${isFullScreenOn ? "question_picked_full_screen_mode_zoom" : "question_picked__content_zoom"} `} onMouseEnter={() => checkIsSoundNeededToBePlayed()}>
                
                {!isAnyCardProposedOnTheTable && isTheUserDilemaOwner && 
                    <div 
                        onMouseEnter={() => setIsExchangeButtonHovered(true)}
                        onMouseLeave={() => setIsExchangeButtonHovered(false) }
                    > 
                            {isExchangeButtonHovered && 
                            <div style={{position: "relative", zIndex: -1}}>
                                 <PinkNotification notificationWidthVW={34} notificationRenderingSide="right" text={t("exchangeTheQuestionCardTextTip")} moveFromTop={10} />
                            </div>
                            }
                            <SwapCardButton cardType="challenge" /> 
                    </div>                    
                }

                {!isAnyCardProposedOnTheTable && isTheUserDilemaOwner && 
                    <div 
                        onMouseEnter={() => setIsJokerButtonHovered(true)}
                        onMouseLeave={() => setIsJokerButtonHovered(false) }
                    > 
                            {isJokerButtonHovered &&
                            <div style={{position: "relative", top: "38vh", zIndex: -1}}>
                                 <PinkNotification notificationWidthVW={34} notificationRenderingSide="right" text={t("replaceTheCurrentChallengeWithTheJokerCardTextTip")} moveFromTop={-10} />
                            </div>
                            }
                            <SwapCardButton cardType="challenge" isThisJokerButton={true} />
                    </div>
                }

                <CardMolecule card={challengeCard.questionCard!} />

                { (isTheFullScreenOn || isDilemmaChosen) && 
                    <div className="dilemma_owner_image_wrapper">
                        <img className="dilemma_owner_question_crown" src={questionCrown} alt="Profile Icon" />
                        <img className={`dilema_owner_image border_color_${dilemmaOwnerColor}`} src={`${process.env.REACT_APP_BACKEND_URL}images/${dilemmaOwner?.email}.png`} alt="Profile Icon" />
                    </div>
                    }
            </div>
            {isDilemmaOwnerButtonShown && isTheUserDilemaOwner && <div className="chosen_dilemma_full_screen_button_wrapper center_horizontally">
                <div className="chosen_dilemma_full_screen_button center_horizontally">
                    <MainButton text={t("doneText")} type="big" clickHandler={() => redirectScreensAfterDilemamWasChosen()} disabled={false} />
                </div>
            </div>}
        </div>
    )
}

export default ChosenDilemmaCard;